import React, { useEffect, useState } from "react";
import { fetchData, fetchFormData } from "../../utils/options";
import { useParams, Link } from "react-router-dom";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import Content2Header from "./Content2Header";
import { FiBookOpen, FiSave, FiVideo } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
const ViewContent = () => {
  const { id } = useParams();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
const navigate=useNavigate()
  // Fetch by ID
  const fetchContentById = async () => {
    try {
      const result = await fetchFormData(`contentbyid/${id}`, {}, "POST");

      if (result?.success || result?.code === 200) {
        const data = result.data;

        data.pdf = Array.isArray(data.pdf)
          ? data.pdf
          : data.pdf
          ? [data.pdf]
          : [];
        data.video = Array.isArray(data.video)
          ? data.video
          : data.video
          ? [data.video]
          : [];
        data.notes = Array.isArray(data.notes)
          ? data.notes
          : data.notes
          ? [data.notes]
          : [];

        setContent(data);
      }
    } catch (error) {
      console.error("Error fetching content:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContentById();
  }, [id]);

  const extractYouTubeID = (url) => {
    const regExp =
      /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[1] ? match[1] : null;
  };

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Content2Header />
          </PageHeader>

          <div className="main-content ">
            <div className="row g-4">
              {/* ===== BASIC DETAILS CARD ===== */}
              <div className="card mb-4 fw-bold">
                <div
                  className="card-header text-white"
                  style={{ backgroundColor: "#0e606e" }}
                >
                  <span className="fw-bold">Content Details</span>
                   <div className="d-flex gap-3">
                   <span
              className="cursor-pointer"
              onClick={() => navigate(`/student/edit-notes/${id}`)}
              title="Edit Notes"
            >
              <FiBookOpen size={16} />
            </span>
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/student/edit-pdf/${id}`)}
              title="Edit Pdf"
            >
              <FiSave size={16} />
            </span>
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/student/edit-video/${id}`)}
              title="Edit Video"
            >
              <FiVideo size={16} />
            </span></div>
                </div>
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-6 mb-2">
                      <strong>Course:</strong>{" "}
                      {content?.course_name || "-"}
                    </div>
                    <div className="col-md-6 mb-2">
                      <strong>Semester:</strong> {content?.semester_name || "-"}
                    </div>
                    <div className="col-md-6 mb-2">
                      <strong>Subject:</strong> {content?.subject_name || "-"}
                    </div>
                    <div className="col-md-6 mb-2">
                      <strong>Chapter:</strong> {content?.chapter_name || "-"}
                    </div>
                    <div className="col-md-6 mb-2">
                      <strong>Title:</strong> {content?.title || "-"}
                    </div>
                    <div className="col-md-6 mb-2">
                      <strong>description:</strong>{" "}
                      {content?.description || "-"}
                    </div>
                    <div className="col-md-6 mb-2">
                      <strong>Thumbnail:</strong>{" "}
                      <img
                        src={content?.thumbnail_url}
                        alt="Thumbnail"
                        className="img-fluid rounded"
                        style={{ maxHeight: "100px", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* PDFs */}
              {Array.isArray(content?.pdf) &&
                content?.pdf.some((p) => p.pdf_file) &&
                content?.pdf.map((item, idx) => (
                  <div key={idx} className="col-md-3 col-sm-6 fw-semibold">
                    <div className="card border shadow-sm text-center d-flex flex-column">
                      <div
                        className="card-header text-black"
                        style={{ background: "#ffa200" }}
                      >
                        PDF: {idx + 1}
                      </div>
                      <div
                        className="card-body d-flex flex-column"
                        style={{ maxHeight: "500px", overflowY: "auto" }}
                      >
                        {item.pdf_url && (
                          <>
                            <div className="small fw-bold text-truncate mb-2">
                              {item?.pdf_file}
                            </div>
                            <a
                              href={item?.pdf_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-primary btn-sm"
                            >
                              View PDF
                            </a>
                          </>
                        )}
                        {item.text && (
                          <p
                            className="text-muted"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            {item.text}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

              {/* videios */}
              {Array.isArray(content?.video) &&
                content?.video.some((v) => v.video_file || v.youtube_url) &&
                content.video.map((item, idx) => (
                  <div key={idx} className="col-md-6 col-sm-12 fw-semibold">
                    <div className="card border shadow-sm ">
                      <div
                        className="card-header text-black "
                        style={{ background: "#ffa200" }}
                      >
                        Video: {idx + 1}
                      </div>
                      <div
                        className="card-body d-flex flex-column"
                        style={{ maxHeight: "400px", overflowY: "auto" }}
                      >
                        {/* YouTube */}
                        {item.is_youtube === 1 && item.youtube_url && (
                          <div className="ratio ratio-16x9">
                            <iframe
                              src={`https://www.youtube.com/embed/${extractYouTubeID(
                                item.youtube_url
                              )}`}
                              title={`Video ${idx + 1}`}
                              allowFullScreen
                            />
                          </div>
                        )}

                        {/* Uploaded Video */}
                        {item.is_youtube === 0 && item.video_url && (
                          <video
                            src={item?.video_url}
                            controls
                            className="w-100 rounded"
                            style={{ maxHeight: "300px" }}
                          />
                        )}
                        {item.text && (
                          <p
                            className="mb-3"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            {item.text}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              {/* Notes */}
              {Array.isArray(content?.notes) &&
                content?.notes.some((n) => n.text || n.image_url) &&
                content?.notes.map((note, idx) => (
                  <div key={idx} className="col-md-4 col-sm-6 fw-semibold">
                    <div className="card border shadow-sm">
                      <div
                        className="card-header text-black "
                        style={{ background: "#ffa200" }}
                      >
                        Note: {idx + 1}
                      </div>
                      <div
                        className="card-body"
                        style={{ maxHeight: "500px", overflowY: "auto" }}
                      >
                        {note.image_url && (
                          <img
                            src={note?.image_url}
                            alt={`Note ${idx + 1}`}
                            className="img-fluid rounded mt-2 mb-2"
                            style={{ maxHeight: "150px", objectFit: "cover" }}
                          />
                        )}
                        {note.text && (
                          <p style={{ whiteSpace: "pre-line" }}>{note?.text}</p>
                        )}
                      </div>

                      {/* <div className="card-body">
                        {note.text && (
                          <p style={{ whiteSpace: "pre-line" }}>{note?.text}</p>
                        )}
                        {note.image_url && (
                          <img
                            src={note?.image_url}
                            alt={`Note ${idx + 1}`}
                            className="img-fluid rounded mt-3"
                            style={{ maxHeight: "150px", objectFit: "cover" }}
                          />
                        )}
                      </div> */}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ViewContent;
